export enum Actions {
  INIT = 'brushWorker:init',
  UPDATE_PROPERTIES = 'brushWorker:update_properties',
  STROKE = 'brushWorker:stroke',
  FINALIZE = 'brushWorker:finalize',
  CLEAR = 'brushWorker:clear',
  UPDATE_LABEL = 'brushWorker:update_label',
}
